import { FunctionComponent, ReactNode, createContext, useContext } from 'react'
import styled from 'styled-components'

import Header from '../Header/Header'
import Footer from '../Footer/Footer'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

const Main = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
`

interface LocationContextInterface {
  pathname: string
}

const LocationContext = createContext<LocationContextInterface>({
  pathname: '/',
})

export const useLocationContext = (): LocationContextInterface => {
  const context = useContext(LocationContext)

  if (context === undefined) {
    throw new Error('useLocationContext must be used within the Layout')
  }

  return context
}

export interface Props {
  children: ReactNode
}

const Layout: FunctionComponent<Props> = ({ children }) => {
  return (
    <LocationContext.Provider value={{ pathname: location.pathname }}>
      <Container>
        <Header />
        <Main>{children}</Main>
        <Footer />
      </Container>
    </LocationContext.Provider>
  )
}

export default Layout
